// #region imports

// --- Angular
import { Component, OnInit, Input, ViewChild, Renderer2, Output, EventEmitter, forwardRef, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// --- 3rd Party
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { SelectListItem } from '../../models';

// #endregion

@Component({
  selector: 'hs-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DemographicsComponent),
      multi: true
    }
  ]
})
export class DemographicsComponent implements OnInit, ControlValueAccessor {
  @Input() controlId: string = '';
  @Input() name: string = '';
  @Input() noResultsLabel: string = '';
  @Input() demographic: SelectListItem[] | null = null;
  @Input() validationMessage: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() lostFocus = new EventEmitter();

  @ViewChild('ddlDemographicValue', { static: true }) ddlDemographicValue: any | undefined;
  @ViewChild('mainfield') mainFieldElement: ElementRef | undefined;
  @ViewChild('popoverRef', { static: true }) popoverRef: NgbPopover | undefined;

  selectedValue: string = '';
  isOpen = false;

  onChange: ((arg0: string) => void) | undefined;
  onTouched: (() => void) | undefined;

  errorMessage: string = '';

  get selectedText(): SelectListItem {
    const selectedDemographic = this.demographic?.find(d => d.value === this.selectedValue);
    if (!selectedDemographic) {
      return {
        text: '',
        group: '',
        isDisabled: false,
        isSelected: true,
        value: '',
      };
    }
    return selectedDemographic;
  }

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    const select = this.ddlDemographicValue.nativeElement;
    this.renderer.setProperty(select, 'disabled', isDisabled);
  }

  writeValue(value: string): void {
    const selectedValue = this.demographic?.find(v => v.value === value);
    if (selectedValue) {
      selectedValue.isSelected = true;
    }
    this.selectedValue = value;
  }

  onDemographicChange(demographicValueId: string): void {
    if (!this.onChange) return;

    this.onChange(demographicValueId);
    this.valueChange.emit(demographicValueId);
    this.selectedValue = demographicValueId;
    this.isOpen = false;
  }

  onFocus(): void {

    if (!this.onTouched) return;

    this.onTouched();
  }

  onBlur(): void {
    this.lostFocus.emit(this);
  }

  displayFn(option: SelectListItem): string {
    return option && option.text ? option.text : '';
  }
}
